import { CheckmarkCircle, InfoCircle, WarningSolid } from '@wfp/icons-react';
import type { FC } from 'react';
import React from 'react';

import { TNotificationType } from 'src/types';

interface Props {
  msg: string | React.JSX.Element;
  type: TNotificationType;
}

const ToastNotification: FC<Props> = ({ msg, type }) => {
  const iconsByType = {
    success: CheckmarkCircle,
    info: InfoCircle,
    error: WarningSolid,
    warning: WarningSolid,
  };
  const IconComponent = iconsByType[type];

  return (
    <div className={`toast-notification-wrapper ${type}`}>
      {IconComponent && (
        <IconComponent
          width="20"
          height="20"
          className={`toast-notification-icon ${type}`}
          style={{ marginRight: '8px' }}
        />
      )}
      <div>{msg}</div>
    </div>
  );
};

export default ToastNotification;
